export const getEnvContext = () => ({
    env: {
        iframe_env: window.sessionStorage.getItem("iframe_env"),
        main_env: window.sessionStorage.getItem("main_env"),
    },
    isInIframe: window.sessionStorage.getItem("isInIframe"),
});
